type NullableString = string | null;

export class Storage {
  private static canUseLocalStorage(): boolean {
    try {
      if (typeof window === 'undefined' || !window.localStorage) return false;
      const testKey = '__encore_storage_test__';
      window.localStorage.setItem(testKey, '1');
      window.localStorage.removeItem(testKey);
      return true;
    } catch {
      return false;
    }
  }

  static get(key: string): NullableString {
    try {
      if (!Storage.canUseLocalStorage()) return null;
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  static set(key: string, value: string): void {
    try {
      if (!Storage.canUseLocalStorage()) return;
      window.localStorage.setItem(key, value);
    } catch {
      // ignore
    }
  }

  static remove(key: string): void {
    try {
      if (!Storage.canUseLocalStorage()) return;
      window.localStorage.removeItem(key);
    } catch {
      // ignore
    }
  }
}
